
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PredialUrbanoService } from 'src/app/Sercivios/predial-urbano.service';
import { ToastService } from 'src/app/Sercivios/toast.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-acreditacion-pago',
  templateUrl: './acreditacion-pago.component.html',
  styleUrls: ['./acreditacion-pago.component.scss']
})
export class AcreditacionPagoComponent implements OnInit, OnDestroy {



  no_autorizacion: string;
  referencia_pago: string;
  folio_recibo: string;

  reintentar: boolean = false;

  environment = environment;

  municipio = "";
  ente = "";
  administracion = "";
  url_escudo = "";
  url_administracion = "";
  url_footer = "";
  direcciones = [];
  telefonos = [];
  emails = [];
  url_aviso = "";
  url_rpt = "";
  cargando = true

  // Banco Azteca: estado del pago segun el backend (que reconcilia con DEUNA).
  // verificando | acreditado | pendiente | rechazado | expirado | sin_pago | sin_orden | revision
  estado_azteca = 'verificando';
  importe: number = null;
  referencia_copiada = false;

  constructor(private route: ActivatedRoute, private router: Router, private padron_predial_service: PredialUrbanoService, private toastService: ToastService) { }

  ngOnInit(): void {
    this.municipio = environment.municipio;
    this.ente = environment.ente;
    this.administracion = environment.administracion;
    this.url_escudo = environment.url_escudo;
    this.url_administracion = environment.url_administracion;
    this.url_footer = environment.url_footer;
    this.direcciones = environment.direcciones;
    this.telefonos = environment.telefonos;
    this.emails = environment.emails;
    this.url_aviso = environment.url_aviso;
    this.folio_recibo = "";
    this.route.params.subscribe(params => {

      if (params.autorizacion != '0' && params.autorizacion != '0' && environment.bbva_rosario) {
        this.folio_recibo = params.folio_recibo;
        this.no_autorizacion = params.autorizacion;
        this.referencia_pago = params.referencia;
        this.cargando = false;
        return
      }

      if (environment.azteca) {
        this.SondearAzteca(params.referencia);
      }
      else if (environment.bajio) {
        this.SondearPago(params);
      }
      else {
        this.folio_recibo = params.folio_recibo;
        this.no_autorizacion = params.autorizacion;
        this.referencia_pago = params.referencia;
        this.cargando = false;
      }
    });
    this.url_rpt = environment.url_rpt;
  }

  // Configuracion del sondeo (polling): consulta el recibo cada cierto intervalo
  // hasta que el banco lo registra, en vez de esperar un tiempo fijo.
  private readonly SONDEO_INTERVALO_MS = 2000;   // cada cuanto reintenta la consulta
  private readonly SONDEO_ESPERA_INICIAL_MS = 1500; // pequeña espera antes del primer intento
  private readonly SONDEO_MAX_MS = 40000;        // tope maximo total de espera
  private sondeoTimeout: any;

  SondearPago(params: any, esperaInicial: number = this.SONDEO_ESPERA_INICIAL_MS) {
    const inicio = Date.now();
    this.reintentar = false;
    this.cargando = true;

    const intentar = () => {
      this.padron_predial_service.GetVerificaRecibo(params.referencia).subscribe(data => {
        // El banco ya registro el recibo -> avanzamos de inmediato.
        if (data && data.length > 0 && data[0].recibo) {
          this.folio_recibo = data[0].recibo;
          this.no_autorizacion = data[0].autorizacion;
          this.referencia_pago = params.referencia;
          this.reintentar = false;
          this.cargando = false;
          return;
        }
        // Aun no responde el banco: reintenta o agota el tope maximo.
        this.reprogramarSondeo(inicio, intentar);
      }, (error: HttpErrorResponse) => {
        // Error transitorio (el recibo aun no existe): seguimos sondeando hasta el tope.
        this.reprogramarSondeo(inicio, intentar);
      });
    };

    this.sondeoTimeout = setTimeout(intentar, esperaInicial);
  }

  private reprogramarSondeo(inicio: number, intentar: () => void) {
    if (Date.now() - inicio >= this.SONDEO_MAX_MS) {
      // Se agoto el tiempo de espera sin respuesta del banco.
      this.toastService.showError('Error al Obtener el recibo de pago. Intente de nuevo.');
      this.reintentar = true;
      this.cargando = false;
      return;
    }
    this.sondeoTimeout = setTimeout(intentar, this.SONDEO_INTERVALO_MS);
  }

  // Banco Azteca: el redirect de DEUNA (success, error o close) no confirma el pago; se pregunta
  // al backend hasta que el estado sea final o se agote el tiempo.
  private readonly AZTECA_INTERVALO_MS = 2500;
  private readonly AZTECA_MAX_MS = 60000;

  SondearAzteca(referencia: string) {
    const inicio = Date.now();
    this.referencia_pago = referencia;
    this.estado_azteca = 'verificando';
    this.reintentar = false;
    // La tarjeta muestra el estado "verificando"; no se usa el overlay de carga.
    this.cargando = false;

    const intentar = () => {
      this.padron_predial_service.GetEstadoPagoAzteca(referencia).subscribe(data => {
        const estado = data && data.estado ? data.estado : 'pendiente';

        if (estado === 'acreditado') {
          this.folio_recibo = data.recibo;
          this.no_autorizacion = data.autorizacion;
          this.importe = data.importe != null ? Number(data.importe) : null;
          this.estado_azteca = estado;
          this.cargando = false;
          return;
        }
        if (estado === 'rechazado' || estado === 'expirado' || estado === 'revision' || estado === 'sin_pago') {
          this.estado_azteca = estado;
          this.cargando = false;
          return;
        }
        this.reprogramarAzteca(inicio, intentar, estado);
      }, () => this.reprogramarAzteca(inicio, intentar, 'pendiente'));
    };

    this.sondeoTimeout = setTimeout(intentar, 0);
  }

  private reprogramarAzteca(inicio: number, intentar: () => void, estado: string) {
    if (Date.now() - inicio >= this.AZTECA_MAX_MS) {
      // Sin respuesta final todavia: el webhook puede tardar; se deja reintentar.
      this.estado_azteca = estado === 'sin_orden' ? 'sin_orden' : 'pendiente';
      this.reintentar = true;
      this.cargando = false;
      return;
    }
    this.sondeoTimeout = setTimeout(intentar, this.AZTECA_INTERVALO_MS);
  }

  ngOnDestroy(): void {
    if (this.sondeoTimeout) {
      clearTimeout(this.sondeoTimeout);
    }
  }

  ImprimirRecibo() {
    window.open(this.url_rpt + "?recibo=" + this.folio_recibo, "_blank")
  }

  Reintentar() {
    if (environment.azteca) {
      this.SondearAzteca(this.route.snapshot.params.referencia);
      return;
    }
    this.cargando = true;
    this.SondearPago(this.route.snapshot.params, 0);
  }

  // Estado que pinta la tarjeta, comun a todos los bancos.
  get estado(): string {
    if (environment.azteca) {
      return this.estado_azteca;
    }
    if (this.cargando) {
      return 'verificando';
    }
    return this.reintentar ? 'pendiente' : 'acreditado';
  }

  get esFinalExitoso(): boolean {
    return this.estado === 'acreditado';
  }

  // Bajio no regresa la autorizacion del banco (salvo BBVA Rosario).
  get mostrarAutorizacion(): boolean {
    const valida = this.no_autorizacion && this.no_autorizacion !== '0';
    return !!valida && (environment.azteca || !environment.bajio || environment.bbva_rosario);
  }

  get mostrarFolio(): boolean {
    return !!this.folio_recibo && this.folio_recibo !== '0';
  }

  CopiarReferencia() {
    const texto = this.referencia_pago || '';
    const listo = () => {
      this.referencia_copiada = true;
      setTimeout(() => this.referencia_copiada = false, 2000);
    };
    const nav: any = navigator;
    if (nav.clipboard && nav.clipboard.writeText) {
      nav.clipboard.writeText(texto).then(listo, () => this.CopiarReferenciaFallback(texto, listo));
    } else {
      this.CopiarReferenciaFallback(texto, listo);
    }
  }

  private CopiarReferenciaFallback(texto: string, listo: () => void) {
    const area = document.createElement('textarea');
    area.value = texto;
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    try {
      document.execCommand('copy');
      listo();
    } finally {
      document.body.removeChild(area);
    }
  }

  Regresar() {
    this.router.navigate([""]);
  }

}
